import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Manipulation, EffectFade } from 'swiper/core';

import 'swiper/css';
import './pdp-carousel.scss';
import './pdp-hero.scss';

SwiperCore.use([Pagination, Navigation, Manipulation, EffectFade]);

export default class pdpHero {
    constructor(el) {
        // if el doesn't exist
        if (!el) return;
        this.hero = el;

        this.carouselEl = el.querySelector(".js-pdp-carousel");
        this.pagination = el.querySelector(".js-pdp-carousel-pagination");
        this.quantityHolder = el.querySelector(".js-quantity-holder");
        this.radioInputs = el.querySelectorAll(".radio-field-holder");
        this.variantSelector = el.querySelector(".js-variant-selector select");
        this.jsonData = JSON.parse(el.querySelector('[data-product-json]').innerHTML);
        this.productData = this.jsonData['product'];
        this.option1 = null;
        this.option2 = null;
        this.option3 = null;

        this.enableSwiper();
        this.init();
        this.bindInputs();
    }

    init () {
        let self = this;
        self.productData['variants'].forEach(function (variant) {
            if (variant['id'] === self.jsonData['selected_variant_id']) {
                self.currentVariant = variant;
                self.option1 = variant['option1'];
                self.option2 = variant['option2'];
                self.option3 = variant['option3'];
                self.variantSelector.value = variant.id;
            }
        });
    }

    bindInputs () {
        let self = this;
        let quantityField = self.quantityHolder.querySelector('.js-quantity-field');
        self.radioInputs.forEach((element) => {
            element.addEventListener('change',()=>{
                self.onVariantChange();
            });
        });
        self.quantityHolder.querySelector('.js-toggle-quantity[data-type="increase"]').addEventListener('click', ()=>{
            let selectedVariantOption = document.querySelector(`.js-variant-selector select option[value='${ self.currentVariant['id'] }']`);
            if(parseInt(quantityField.value) < selectedVariantOption.dataset.maxQuantity) {
                quantityField.value = parseInt(quantityField.value) + 1;
            }
        });
        self.quantityHolder.querySelector('.js-toggle-quantity[data-type="decrease"]').addEventListener('click', ()=>{
            if(parseInt(quantityField.value) > 1) {
                quantityField.value = parseInt(quantityField.value) - 1;
            }
        });
    }

    enableSwiper () {
        let self = this;
        self.carousel = new Swiper(self.carouselEl, {
            loop: false,
            spaceBetween: 0,
            pagination: {
                el: self.pagination,
            }
        });
    }

    onVariantChange () {
        let self = this;
        let option1 = null;
        let option2 = null;
        let option3 = null;
        if(document.querySelector('[name="option1"]')) {
            option1 = document.querySelector('[name="option1"]:checked').value;
        }
        if(document.querySelector('[name="option2"]')) {
            option2 = document.querySelector('[name="option2"]:checked').value;
        }
        if(document.querySelector('[name="option3"]')) {
            option3 = document.querySelector('[name="option3"]:checked').value;
        }
        self.productData['variants'].forEach(function (variant) {
            if(variant.option1 == option1 && variant.option2 == option2 && variant.option3 == option3) {
                self.currentVariant = variant;
                self.option1 = variant['option1'];
                self.option2 = variant['option2'];
                self.option3 = variant['option3'];
                self.variantSelector.value = variant.id;
            }
        });
        let quantityField = self.quantityHolder.querySelector('.js-quantity-field');
        let selectedVariantOption = document.querySelector(`.js-variant-selector select option[value='${ self.currentVariant['id'] }']`);
        if(parseInt(quantityField.value) > selectedVariantOption.dataset.maxQuantity) {
            quantityField.value = parseInt(selectedVariantOption.dataset.maxQuantity);
        }
    }
}